"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendNewPassword = exports.forgotPasswordRequest = exports.updateUser = exports.getUserData = exports.postLogin = void 0;
var axios_1 = __importDefault(require("axios"));
var catchAxiosError_1 = __importDefault(require("../util/catchAxiosError"));
var postLogin = function (data) {
    return axios_1.default
        .post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/jwt-auth/v1/token"), data.payload)
        .catch(catchAxiosError_1.default);
};
exports.postLogin = postLogin;
var getUserData = function (token) {
    return axios_1.default
        .post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/users/me?_embed"), {}, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    })
        .catch(catchAxiosError_1.default);
};
exports.getUserData = getUserData;
var updateUser = function (body) {
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/user"), body, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
exports.updateUser = updateUser;
var forgotPasswordRequest = function (_a) {
    var email = _a.email;
    return axios_1.default.post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/users/lostpassword"), {
        user_login: email
    }, {
        headers: { 'Content-Type': 'application/json' }
    }).catch(catchAxiosError_1.default);
};
exports.forgotPasswordRequest = forgotPasswordRequest;
var sendNewPassword = function (_a) {
    var email = _a.email, newPassword = _a.newPassword, key = _a.key;
    return axios_1.default.post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/users/resetpassword"), {
        rp_key: key,
        rp_login: email,
        new_password: newPassword
    }, {
        headers: { 'Content-Type': 'application/json' }
    }).catch(catchAxiosError_1.default);
};
exports.sendNewPassword = sendNewPassword;
